import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fetchBlog } from "../../lib/apiClient";

export const BlogSection = () => {
  const { data: posts = [], isLoading } = useQuery({ queryKey: ["blog"], queryFn: fetchBlog });

  return (
    <section id="journal" data-testid="journal-section" className="py-24 lg:py-36 bg-white border-y border-slate-200">
      <div className="mx-auto max-w-7xl section-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="label-caps text-berry mb-4">Journal</p>
            <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-navy">
              Notes on finance &amp; strategy
            </h2>
          </div>
        </div>

        {isLoading ? (
          <div className="grid md:grid-cols-3 gap-8">
            {[0, 1, 2].map((i) => (
              <div key={i} className="h-64 bg-slate-100 rounded-sm animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-3 gap-8">
            {posts.map((post, i) => (
              <motion.div
                key={post.id}
                data-testid={`blog-card-${post.slug}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                <Link
                  to={`/journal/${post.slug}`}
                  className="group block h-full border border-slate-200 rounded-sm p-8 hover:border-berry hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow,border-color] duration-300 bg-white"
                >
                  <div className="flex items-center justify-between mb-6">
                    <span className="label-caps text-berry">{post.category}</span>
                    <ArrowUpRight size={18} className="text-slate-400 group-hover:text-berry transition-colors duration-200" />
                  </div>
                  <h3 className="font-serif text-2xl text-navy leading-snug group-hover:text-berry transition-colors duration-200">
                    {post.title}
                  </h3>
                  <p className="mt-4 text-sm text-slate-500 leading-relaxed">{post.excerpt}</p>
                  <div className="mt-8 flex items-center gap-3 text-xs text-slate-400">
                    <span>{new Date(post.published_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}</span>
                    <span className="w-1 h-1 bg-slate-300 rounded-full" />
                    <span>{post.read_time}</span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
